"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_native_1 = require("react-native");
const react_native_safe_area_context_1 = require("react-native-safe-area-context");
const react_redux_1 = require("react-redux");
const BackHeader_1 = __importDefault(require("../../../assets/icons/BackHeader"));
const components_1 = require("../../../components");
const ModalUnFollow_1 = __importDefault(require("../../../components/modal/ModalUnFollow"));
const CustomText_1 = __importDefault(require("../../../components/text/CustomText"));
const rootNavigation_1 = require("../../../navigators/rootNavigation");
const Routes_1 = __importDefault(require("../../../navigators/Routes"));
const Basic_1 = __importDefault(require("../../../networking/apis/Basic"));
const helpler_1 = require("../../../utils/helpler");
const scale_1 = require("../../../utils/scale");
const DisconnectScreen_1 = require("../../DisconnectScreen");
const styles_1 = __importDefault(require("./styles"));
const FollowTag = () => {
    const inset = (0, react_native_safe_area_context_1.useSafeAreaInsets)();
    const connected = (0, react_redux_1.useSelector)((state) => state.appReducer.connected);
    const [modalPosition, setModalPosition] = (0, react_1.useState)({ x: 0, y: 0 });
    const [followTags, setFollowTags] = (0, react_1.useState)([]);
    const [selectedHashtag, setSelectedHashtag] = (0, react_1.useState)();
    const [isLoading, setLoading] = (0, react_1.useState)(true);
    const [isLoadMore, setLoadMore] = (0, react_1.useState)(false);
    const refCurrentPage = (0, react_1.useRef)(1);
    const refIsNoMore = (0, react_1.useRef)(false);
    const refIsCallingAPI = (0, react_1.useRef)(false);
    const modalVisible = !!selectedHashtag;
    const [checkLoadMore, setCheckLoadMore] = (0, react_1.useState)(false);
    (0, react_1.useEffect)(() => {
        if (connected) {
            loadFollowTags();
        }
    }, [connected]);
    const loadFollowTags = () => {
        if (refIsNoMore.current || isLoadMore)
            return;
        setLoadMore(true);
        Basic_1.default.getFollowHashtags(refCurrentPage.current)
            .then(response => {
            refCurrentPage.current = refCurrentPage.current + 1;
            if (refCurrentPage.current > response.data.last_page) {
                refIsNoMore.current = true;
                setCheckLoadMore(true);
            }
            if (response?.data?.data?.length > 0) {
                setFollowTags([...followTags, ...response.data.data]);
            }
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => { setLoading(false), setLoadMore(false); });
    };
    const handleUnfollowHashtag = () => {
        const id = selectedHashtag?.hash_tag_id;
        if (refIsCallingAPI.current || !id)
            return;
        refIsCallingAPI.current = true;
        setSelectedHashtag(undefined);
        Basic_1.default.unfollowHashtag(id)
            .then(() => {
            setFollowTags((prev) => prev.map((follower) => {
                if (follower.hash_tag_id === id) {
                    return { ...follower, is_followed: 0 };
                }
                return follower;
            }));
        })
            .catch((err) => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handleFollowHashtag = (hashtagId) => {
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.followHashtag(hashtagId)
            .then(() => {
            setFollowTags((prev) => prev.map((follower) => {
                if (follower.hash_tag_id === hashtagId) {
                    return { ...follower, is_followed: 1 };
                }
                return follower;
            }));
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const handlePress = (event, hashtag) => {
        if (hashtag.is_followed == 0) {
            handleFollowHashtag(hashtag.hash_tag_id);
        }
        else {
            const { pageY } = event.nativeEvent;
            setModalPosition({ x: (0, scale_1.scale)(293), y: pageY });
            setSelectedHashtag(hashtag);
        }
    };
    const handleUpdatePrivateHashtag = (hashtagId, isPrivate) => {
        if (refIsCallingAPI.current)
            return;
        refIsCallingAPI.current = true;
        Basic_1.default.editFollowHashtag(hashtagId, isPrivate)
            .then((_response) => {
            const newState = followTags.map((item) => {
                if (item.hash_tag_id === hashtagId) {
                    return { ...item, is_private: isPrivate };
                }
                return item;
            });
            setFollowTags(newState);
        })
            .catch(err => {
            console.log(err);
        })
            .finally(() => {
            refIsCallingAPI.current = false;
        });
    };
    const renderItem = ({ item }) => {
        const isFollowed = item.is_followed == 1;
        const isPrivate = item.is_private == 1;
        return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainItem },
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.hashtagView },
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: styles_1.default.textTitle, numberOfLines: 2 },
                    "#",
                    item?.name)),
            react_1.default.createElement(react_native_1.View, { style: styles_1.default.mainButton },
                react_1.default.createElement(react_native_1.TouchableOpacity, { style: [
                        styles_1.default.buttonFollow,
                        isFollowed && styles_1.default.buttonInactive,
                    ], onPress: (event) => handlePress(event, item) },
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: [
                            styles_1.default.textFollow,
                            isFollowed && { color: "#545454" },
                        ] }, isFollowed ? "フォロー中" : "フォロー")),
                react_1.default.createElement(react_native_1.View, { style: { marginBottom: (0, scale_1.scale)(8) } }),
                react_1.default.createElement(react_native_1.TouchableOpacity, { onPress: () => handleUpdatePrivateHashtag(item.hash_tag_id, isPrivate ? 0 : 1), style: [
                        styles_1.default.buttonPrivate,
                        isPrivate && styles_1.default.buttonInactive
                    ] },
                    react_1.default.createElement(CustomText_1.default, { weight: "300", style: [
                            styles_1.default.textPrivate,
                            isPrivate && { color: "#292A33" },
                        ] }, isPrivate ? "非公開" : "公開")))));
    };
    if (!connected)
        return react_1.default.createElement(DisconnectScreen_1.DisconnectScreen, null);
    return (react_1.default.createElement(react_native_1.View, { style: styles_1.default.container },
        react_1.default.createElement(components_1.Header, { statusBarStyle: "dark-content", styleViewCenter: { alignItems: 'center' }, title: 'フォローしたタグ', styleContainer: {
                backgroundColor: 'white',
            }, leftIcon: react_1.default.createElement(BackHeader_1.default, { color: '#292A33' }) }),
        isLoading ? (react_1.default.createElement(react_native_1.View, { style: {
                position: 'absolute',
                left: 0,
                right: 0,
                top: 0,
                bottom: 0,
                backgroundColor: '#F5FCFF88',
                alignItems: 'center',
                justifyContent: 'center',
            } },
            react_1.default.createElement(react_native_1.ActivityIndicator, { size: "large", color: '#286D84' }))) : (react_1.default.createElement(react_native_1.FlatList, { data: followTags, renderItem: renderItem, keyExtractor: (item) => `${item.hash_tag_id}`, contentContainerStyle: {
                paddingTop: (0, scale_1.scale)(24),
                paddingBottom: inset.bottom + (0, scale_1.scale)(100),
            }, onScroll: ({ nativeEvent }) => {
                if ((0, helpler_1.isCloseToBottom)(nativeEvent)) {
                    loadFollowTags();
                }
            }, scrollEventThrottle: 400, ListFooterComponent: isLoadMore ? (react_1.default.createElement(components_1.LoadingView, { style: styles_1.default.loading })) : (react_1.default.createElement(react_native_1.View, { style: { width: '100%', alignItems: 'center' } }, followTags?.length > 0 && checkLoadMore && (react_1.default.createElement(react_native_1.View, { style: { width: (0, scale_1.scale)(224), marginTop: (0, scale_1.scale)(32) } },
                react_1.default.createElement(CustomText_1.default, { style: {
                        fontSize: (0, scale_1.moderateScale)(15),
                        lineHeight: (0, scale_1.moderateScale)(23),
                        color: '#292A33',
                        textAlign: 'center',
                    } }, "\u30D5\u30A9\u30ED\u30FC\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u5897\u3084\u3057\u3066 \u30D7\u30ED\u30D5\u30A3\u30FC\u30EB\u3092\u5145\u5B9F\u3055\u305B\u307E\u3057\u3087\u3046"),
                react_1.default.createElement(components_1.LinearButton, { containerStyle: {
                        marginTop: (0, scale_1.scale)(16),
                    }, title: "\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u63A2\u3059", onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.HASHTAG,
                        });
                    }, style: {
                        height: (0, scale_1.scale)(32),
                        width: (0, scale_1.scale)(174),
                        marginLeft: (0, scale_1.scale)(25),
                        borderRadius: (0, scale_1.moderateScale)(4)
                    }, textStyle: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                    } }))))), ListEmptyComponent: react_1.default.createElement(react_native_1.View, { style: {
                    marginTop: (0, scale_1.scale)(32),
                    width: '100%',
                    justifyContent: 'center',
                    paddingHorizontal: (0, scale_1.scale)(16),
                } },
                react_1.default.createElement(CustomText_1.default, { weight: "600", style: {
                        fontSize: (0, scale_1.moderateScale)(16),
                        lineHeight: (0, scale_1.moderateScale)(24),
                        textAlign: 'center',
                        color: '#292A33',
                    } }, "\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u30D5\u30A9\u30ED\u30FC\u3057\u307E\u305B\u3093\u304B?"),
                react_1.default.createElement(CustomText_1.default, { weight: "300", style: {
                        fontSize: (0, scale_1.moderateScale)(14),
                        lineHeight: (0, scale_1.moderateScale)(21),
                        textAlign: 'center',
                        color: '#292A33',
                        marginTop: (0, scale_1.scale)(8),
                    } }, "\u6C17\u306B\u306A\u308B\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u30D5\u30A9\u30ED\u30FC\u3057\u3066\u3001\u5171\u901A\u306E\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u30D5\u30A9\u30ED\u30FC\u3057\u3066\u3044\u308B\u5148\u8F29\u3068\u4EA4\u6D41\u3092\u6DF1\u3081\u3066\u3044\u304D\u307E\u3057\u3087\u3046!"),
                react_1.default.createElement(components_1.LinearButton, { containerStyle: { marginTop: (0, scale_1.scale)(24) }, fontWeight: "600", title: "\u30CF\u30C3\u30B7\u30E5\u30BF\u30B0\u3092\u63A2\u3059", onPress: () => {
                        (0, rootNavigation_1.navigate)(Routes_1.default.HIDDEN_TAB_NAVIGATOR, {
                            screen: Routes_1.default.HASHTAG,
                        });
                    } })) })),
        react_1.default.createElement(ModalUnFollow_1.default, { visible: modalVisible, onClose: () => setSelectedHashtag(undefined), modalPosition: modalPosition, hashTag: `${selectedHashtag?.name}の`, openModalNoti: handleUnfollowHashtag })));
};
exports.default = FollowTag;
